import type { FaireProductEntity } from "../../entity_types/product";

export const p_rpkkfvsm9k: FaireProductEntity = {
  token: "p_rpkkfvsm9k",
  type: "product",
  name: "Crystal Prescriptions 4: Chakra & Kundalini Awakening",
  brandToken: "b_elwnrzazbf",
  brandName: "Microcosm Publishing & Distribution",
  imageUrl:
    "https://cdn.faire.com/fastly/6f5f69281d926ea23fb749a03687218b5a05909845e677bceeaeb888b8ec1db6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e96b2ed0b7985b8a4032fca24ba491de5bd5df7b4c15f93ecf37da1891226ea5.jpeg",
    "https://cdn.faire.com/fastly/53c9f1e8d19f059b72fe8220c45ea5b978cc9a723e2ea3a49420c60f088bcaa0.jpeg",
  ],
  priceDollars: 17.42,
  description:
    "(Volume 4) Crystal Prescriptions: The A-Z Guide To Chakra and Kundalini Awakening Crystals\nThis directory provides all you need to know about crystals for the chakras, subtle energy bodies and raising kundalini. There are many more chakras than the conventional seven that have traditionally been in use. As the frequency of the human organism is raised, additional chakras are opening up to assimilate higher dimensional energy. This frequency uplift, and overall well-being, can be facilitated by stimulating the rise of kundalini energy, which in turn can be activated with appropriate crystals. However, spontaneous kundalini awakening can be overwhelming. Fortunately crystals have the answer. This new directory in the A-to-Z series assists you to identify exactly the right crystal to release any blockages and return the chakras to a state of equilibrium. This will enable the higher chakras to open and controlled kundalini rise to occur. (medium discount)",
  tags: [],
  msrpDollars: 24.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:19.546Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
